import React, { Component } from 'react';
import { List } from 'react-virtualized';
import SelectableItem from './SelectableItem';

class DynamicMultiSelect extends Component {
    constructor(props) {
        super(props);
        this.timeout = null;
        this.state = {
            items: [],
            listHeight: 300,
            listRowHeight: 5,
            overscanRowCount: 10,
            rowCount: this.props.items.length,
            scrollToIndex: undefined,
            showScrollingPlaceholder: false,
            useDynamicRowHeight: true,
            width: 300,
            selectAll: false,
            selected: [],
            filter: '',
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.selected !== prevState.selected) {
            return { selected: nextProps.selected };
        } else return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selected !== this.props.selected) {
            this.setState({ selected: this.props.selected });
            this.refs.list.forceUpdateGrid();
        }
    }

    componentDidMount() {
        if (this.state.filter === '') {
            this.setState({ items: this.props.items });
        }
    }

    renderItems = (index, isScrolling, isVisible, key, parent, style) => {
        const item = this.state.items[index.index];
        return (
            <SelectableItem
                key={index.index}
                id={item.id}
                name={item.name}
                selected={this.state.selected.includes(item.id) ? true : false}
                callBackFunction={() => {
                    this.removeAll();
                    this.props.callBackFunction(item.id);
                }}
            />
        );
    };

    removeAll = () => {
        this.setState({ selectAll: false });
        this.refs.list.forceUpdateGrid();
    };

    selectAll = () => {
        this.props.callBackAllFunction(!this.state.selectAll);
        this.setState({ selectAll: !this.state.selectAll });
    };

    filter = event => {
        clearTimeout(this.timeout);
        this.setState({
            filter: event.target.value,
        });
        this.timeout = setTimeout(
            function() {
                this.filterItems();
            }.bind(this),
            1000
        );
    };

    filterItems = () => {
        if (this.state.filter !== '') {
            const result = this.props.items.filter(org => {
                return org.name
                    .toLowerCase()
                    .includes(this.state.filter.toLowerCase());
            });
            this.setState({ items: result });
        } else {
            this.setState({ items: this.props.items });
        }
    };

    render() {
        const {
            listRowHeight,
            overscanRowCount,
            scrollToIndex,
            items,
            selectAll,
            filter,
        } = this.state;
        if (items.length < 0) {
            return <div>No Selections ...</div>;
        }
        return (
            <div className="dynamicMultiSelect">
                <div className="menu">
                    <div
                        className={`all_button ${selectAll ? 'selected' : ''}`}>
                        <span
                            key={true}
                            type="checkbox"
                            name
                            value
                            onClick={() => {
                                this.selectAll();
                            }}
                        />
                        All
                    </div>
                    <div className="dynamicmultiselect_filter">
                        <label>Filter</label>
                        <input
                            type="text"
                            name="dynamicmultiselect_filter"
                            value={filter}
                            onChange={this.filter}
                        />
                    </div>
                </div>
                <div className="dropdown_content_container">
                    <List
                        ref="list"
                        className="drpdown_list"
                        overscanRowCount={overscanRowCount}
                        rowCount={items.length}
                        rowHeight={listRowHeight}
                        rowRenderer={this.renderItems}
                        scrollToIndex={scrollToIndex}
                        autoWidth={true}
                        width={500}
                        height={300}
                        selectedItems={this.props.selected}
                    />
                </div>
            </div>
        );
    }
}

export default DynamicMultiSelect;
